// extracted by mini-css-extract-plugin
export default {"form":"EventForm_form__F3YHq","actions":"EventForm_actions__yj6Wu"};